import React from "react";

import { Link } from "react-router-dom";

import { useAuth } from "./../../hooks/auth";

import {
  Container,
  Content,
  About7CantosContainer,
  LoginContainer,
  UserRoutesContainer,
  FirstOptionsContainer,
  SecondOptionsContainer,
  RoutesContainer,
  SettingsContainer,
} from "./styles";

import logo7cantosImg from "./../../assets/components/Menu/7-cantos-logo.png";
import DecorImage from "../../assets/components/Menu/7Cantos_Decor.svg";
import { FaCalendarAlt, FaUsers } from "react-icons/fa";
import { GiWallet } from "react-icons/gi";
import { BsHouseFill } from "react-icons/bs";
import { BiX } from "react-icons/bi";
import { MdDashboard } from "react-icons/md";
import { canManageSubLogins } from "../../utils/canManageSubLogins";

interface IMenuProprietarioToMobile {
  functionToCloseMenuProprietarioToMobile(): void;
}

export default function MenuProprietarioToMobile({
  functionToCloseMenuProprietarioToMobile,
}: IMenuProprietarioToMobile) {
  const { user, logOut } = useAuth();
  const showAccessManagement = canManageSubLogins(user);
  const isAdminUser =
    user?.type === "admin" ||
    user?.role === "admin" ||
    user?.is_admin === true ||
    user?.isAdmin === true;

  const loginFallback = {
    pathname: "/login",
    state: { fromSite: true },
  };

  return (
    <Container>
      <Content>
        <button onClick={functionToCloseMenuProprietarioToMobile}>
          <BiX size={32} color="#FFF" />
        </button>

        <LoginContainer>
          {!user && (
            <>
              <h2>ACESSE SUA CONTA</h2>

              <Link to={loginFallback}>ENTRAR</Link>
            </>
          )}

          {!!user && <h2>Olá, {user.first_name}</h2>}
        </LoginContainer>

        <hr />

        <About7CantosContainer>
          {isAdminUser && (
            <Link
              to="/style-guide"
              onClick={functionToCloseMenuProprietarioToMobile}
            >
              <p>Guia de estilo</p>
            </Link>
          )}
          <Link to="/about-us">
            <img src={logo7cantosImg} alt="logo7cantosImg" />
            <p>Sobre a 7Cantos</p>
          </Link>

          <a href="https://decor.7cantos.com/">
            <img src={DecorImage} alt="7Cantos_Decor" className="logo-7decor" />
            <p>Sobre a 7Decor</p>
          </a>
        </About7CantosContainer>

        <hr />

        <UserRoutesContainer>
          {!!user && <h3>PROPRIETÁRIO</h3>}

          <RoutesContainer>
            <FirstOptionsContainer>
              <Link to={!!user ? "/my-properties" : loginFallback}>
                <BsHouseFill size={28} color="#FFF" />
                <p>Meus Imóveis</p>
              </Link>

              <Link to={!!user ? "/scheduled-visits" : loginFallback}>
                <FaCalendarAlt size={28} color="#FFF" />
                <p>Visitas Agendadas</p>
              </Link>
            </FirstOptionsContainer>

            <SecondOptionsContainer>
              <Link to={!!user ? "/proposals" : loginFallback}>
                <GiWallet size={28} color="#FFF" />
                <p>Propostas Recebidas</p>
              </Link>

              <Link
                to={"/owner-dashboard"}
                onClick={functionToCloseMenuProprietarioToMobile}
              >
                <MdDashboard size={27} color="#FFF" />
                <p>Área do Proprietário</p>
              </Link>
            </SecondOptionsContainer>

            {showAccessManagement && (
              <SecondOptionsContainer>
                <Link
                  to={"/access-management"}
                  onClick={functionToCloseMenuProprietarioToMobile}
                >
                  <FaUsers size={28} color="#FFF" />
                  <p>Gestão de Acessos</p>
                </Link>
              </SecondOptionsContainer>
            )}
          </RoutesContainer>
        </UserRoutesContainer>

        <hr />

        {!!user && (
          <SettingsContainer>
            <Link to="/me">Editar Perfil</Link>

            <button onClick={logOut}>Sair</button>
          </SettingsContainer>
        )}
      </Content>
    </Container>
  );
}
